import {DictType} from "./dictType.model";
import {DossierDate, DossierN3, DossierT100, DossierT250} from "./base.model";
import {ClientInfo} from "./clientInfo.model";
import {PartItemArray} from "../partItemArray.model";

export class SvedIOUInfoType extends PartItemArray{
  organUpr: DictType = undefined;
  organUprOther: DossierT250 = '';
  base: DossierT250 = '';
  dateFromV: DossierDate = '';
  dateEndV: DossierDate = '';
  type: DictType = undefined;
  part: DossierN3 = undefined;
  vidKolOU: DictType = undefined;
  otherOU: DossierT250 = '';
  sostavIO: SostavIOType[] = [];
  post: DictType = undefined;
  otherPost: DossierT250 = '';
  dateResh: DossierDate = '';
  numberResh: DossierT100 = '';
  docName: DossierT250 = '';
  clientInfo: ClientInfo = new ClientInfo();
}

export class SostavIOType {
  fio: DossierT250 = '';
  dateFrom = false;
  dateEnd = false;
  row: number;
}